import React from "react";
import { Flight } from "../../models/flight";

export interface DelayedFlightRowProps {
    item: Flight
    index: number
}

export class DelayedFlightRow extends React.Component<DelayedFlightRowProps,DelayedFlightRowProps> {

    render() {
        return (
            <div className="row py-1 align-items-center" 
                style={this.props.index % 2 === 0 ? { 'background': 'white' } : { 'background': 'rgb(215, 225, 238)' }}
                key={this.props.item.ID + this.props.item.Destination}>

                <div className="col-md-3 col-6 no-gutters px-0" style={{ textAlign: 'center' }}>
                    <div className="col-12"><label className="d-md-none font-weight-bold"><u>Airline</u></label>
                    </div>
                    <div className="col-12"><img className="img-fluid" src={this.props.item.LogoSmall}
                        alt={this.props.item.Airline} /><br />
                    </div>
                    {this.props.item.CodeShares.map((cs) => <div
                        key={cs} className="small text-md-right col-12 no-gutters"
                        style={{ padding: '0px', fontStyle: 'italic' }}><b>{cs}</b></div>)}
                </div>
                <div className="col-md-1 col-6 px-0" style={{ textAlign: 'center' }}>
                    <div className="col-12"><label className="d-md-none font-weight-bold"><u>Flight#</u></label>
                    </div>
                    <div className="col-12"> {this.props.item.Flightnumber}</div>
                </div>
                <div className="col-md-3 col-6 px-0" style={{ textAlign: 'center' }}>
                    <div className="col-12"><label className="d-md-none font-weight-bold"><u>City</u></label>
                    </div>
                    {this.props.item.Destination.replace('/', ' / ')}
                </div>
                <div className="col-md-2 col-6 px-0" style={{ textAlign: 'center' }}>
                    <div className="col-12"><label
                        className="d-md-none font-weight-bold"><u>Scheduled</u></label></div>
                    {this.props.item.ScheduledDateTime}
                </div>
                <div className="col-md-1 col-6 px-0" style={{ textAlign: 'center' }}>
                    <div className="col-12"><label
                        className="d-md-none font-weight-bold"><u>Terminal</u></label></div>
                    {this.props.item.Terminal}
                </div>
                {/* <div className="col-md-1 col-6 px-0" style={{ textAlign: 'center' }}>
                    <div className="col-12"><label className="d-md-none font-weight-bold"><u>Gate</u></label>
                    </div>
                    {this.props.item.Gate}
                </div> */}
                <div className="col-md-1 col-6 px-0" style={{ textAlign: 'center' }}>
                    <div className="col-12"><label className="d-md-none font-weight-bold"><u>Status</u></label>
                    </div>
                    {this.props.item.Status}
                </div>
                <div className="col-md-1 col-6 align-middle px-0" style={{ textAlign: 'center' }}>
                    <div className="col-12"><label className="d-md-none font-weight-bold"><u>Status Code</u></label></div>
                    {this.props.item.StatusCode}

                </div>
                <div className="col-12 col-md-1 px-0 mx-0 py-1">
                    <div className=" row justify-content-center mx-0">
                        <div className="col-8 col-md-12 px-0 mx-0">
                            
                        </div>
                    </div>

                </div>
                <div className="col-12 col-md-1 px-0 mx-0 py-1 d-md-none">
                    <div className=" row justify-content-center mx-0">
                        <div className="col-8 col-md-12 px-0 mx-0">
                            
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}